import React from 'react';
import { Button } from '../shared/Button';
import { Card } from '../shared/Card';
interface EnergyLevelProps {
  selected: string;
  onSelect: (value: string) => void;
  onNext: () => void;
  onBack: () => void;
}
export const EnergyLevel = ({
  selected,
  onSelect,
  onNext,
  onBack
}: EnergyLevelProps) => {
  const energyOptions = [{
    value: 'low',
    label: 'Low',
    emoji: '🌙',
    description: 'Just enough energy to move'
  }, {
    value: 'medium',
    label: 'Medium',
    emoji: '🔆',
    description: 'Moderate energy levels'
  }, {
    value: 'high',
    label: 'High',
    emoji: '⚡',
    description: 'Ready to crush a workout'
  }];
  return <div className="flex flex-col h-full p-6" data-id="element-709">
      <div className="mb-8" data-id="element-710">
        <button onClick={onBack} className="text-gray-500 mb-4" data-id="element-711">
          ← Back
        </button>
        <h1 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-712">
          When you open FitFuel, how do you usually feel?
        </h1>
        <p className="text-gray-600" data-id="element-713">
          We'll match workout intensity to how you're feeling.
        </p>
      </div>
      <div className="space-y-4 mb-8" data-id="element-714">
        {energyOptions.map(option => <Card key={option.value} onClick={() => onSelect(option.value)} active={selected === option.value} className="p-5" data-id="element-715">
            <div className="flex items-center" data-id="element-716">
              <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mr-4 text-2xl" data-id="element-717">
                {option.emoji}
              </div>
              <div data-id="element-718">
                <h3 className="font-medium text-lg" data-id="element-719">{option.label}</h3>
                <p className="text-gray-500 text-sm" data-id="element-720">{option.description}</p>
              </div>
            </div>
          </Card>)}
      </div>
      <div className="mt-auto" data-id="element-721">
        <Button onClick={onNext} variant="primary" fullWidth disabled={!selected} className={!selected ? 'opacity-50 cursor-not-allowed' : ''} data-id="element-722">
          Continue
        </Button>
      </div>
    </div>;
};